import Loader from '@streamster/shared/components/Loader/Loader';
import { AuthContext } from '@streamster/shared/screens/auth/auth.utils';
import { useContext, useEffect } from 'react';
import styles from './AuthCallback.module.scss';
import { navigationRef, useAppNavigation, useAppRoute } from '@streamster/shared/navigation/navigation.ref';
import { ToasterContext } from '@streamster/shared/toaster/toaster.provider';
import { useInitialRouteStore } from '@streamster/shared/navigation/initialRouteStore';

export const AuthCallbackScreen = () => {
  const { loginWithToken, logout, accessToken } = useContext(AuthContext);
  const { params } = useAppRoute<'AuthCallback'>();
  const navigation = useAppNavigation();
  const toaster = useContext(ToasterContext);
  const { isAuth } = useContext(AuthContext);
  const initialRouteStore = useInitialRouteStore();

  useEffect(() => {
    if (!navigation) {
      return;
    }

    (async () => {
      if (params?.token) {
        if (accessToken) {
          await logout();
        }
        if (params?.redirect) {
          const { redirect, token, ...redirectParams } = params;
          initialRouteStore.setInitialRoute({ name: redirect, params: redirectParams });
        }
        await loginWithToken({ token: params?.token }).catch(() => {
          setTimeout(() => {
            toaster.error({ message: 'Invalid token or expired session. Please try again.' });
            navigationRef.current?.navigate('SignIn');
          });
        });

        setTimeout(() => {
          navigationRef.current?.reset({
            index: 0,
            routes: [{ name: 'Connect' }],
          });
        }, 100);
      } else {
        setTimeout(() => {
          navigationRef.current?.navigate(isAuth ? 'Home' : 'SignIn');
        }, 100);
      }
    })();
  }, [loginWithToken, params?.token, params?.redirect, navigation]);

  return (
    <div className={styles.wrapper}>
      <Loader size={50} />
      <h3 className={styles.title}>Authenticating...</h3>
    </div>
  );
};
